import './style.css';
/*
lg:grid-cols-6 float-left float-right
*/
console.log('%c Welcome to Selective Asia', 'padding:20px;font-weight: bold; font-size: 50px;color: red; text-shadow: 3px 3px 0 rgb(217,31,38) , 6px 6px 0 rgb(226,91,14) , 9px 9px 0 rgb(245,221,8) , 12px 12px 0 rgb(5,148,68) , 15px 15px 0 rgb(2,135,206) , 18px 18px 0 rgb(4,77,145) , 21px 21px 0 rgb(42,21,113)');
(()=>{
    try{
        var gclid = '';
        try {
            gclid = window.top.location.search.substring(1).split('&').find((e)=>e.startsWith('gclid=')).split('=')[1].trim();
        }
        catch (e) {
            // console.error('Failed parsing gclid', e)
            gclid = '';
        }
        if(gclid != ''){
            var storedValue = localStorage.getItem('sa_gclids') || "[]";
            var sa_gclids = JSON.parse(storedValue);
            var foundIt = false;
            for (var i = 0; i < sa_gclids.length && !foundIt; i++) {
                var element = sa_gclids[i];
                if(element == gclid){
                    foundIt = true;
                }
            }
            if(!foundIt){
                sa_gclids.push(gclid);
            }
            localStorage.setItem('sa_gclids',JSON.stringify(sa_gclids));
        }
    }catch(ex){
        console.error('Failed storing gclid',ex)
    }
})();
(function () {
  if (window.parent === window) return;               // not framed → do nothing

  var ALLOWED_PARENTS = [
    'https://www.selectiveasia.com',
    'https://staging.selectiveasia.com',
    'https://newcms.example.com'
  ];

  var parentOrigin = null;

  function height() {
    var b = document.body;
    if (!b) return 0;
    // Lowest content edge, measured from document top — independent of iframe size.
    var max = b.offsetHeight;
    var kids = b.children;
    for (var i = 0; i < kids.length; i++) {
      var bottom = kids[i].getBoundingClientRect().bottom + window.scrollY;
      if (bottom > max) max = bottom;
    }
    return Math.ceil(max);
  }

  var last = 0;
  function send() {
    if (!parentOrigin) return;
    var h = height();
    if (!h || Math.abs(h - last) < 2) return;          // dead-zone kills jitter
    last = h;
    parent.postMessage({ type: 'sa-legacy:height', height: h }, parentOrigin);
  }
  window.toTop = function() {
    if (!parentOrigin) return;
    parent.postMessage({ type: 'sa-legacy:to-top' }, parentOrigin);
  }

  // Handshake: parent posts 'sa-legacy:init', we lock onto its origin.
  window.addEventListener('message', function (e) {
    if (!e.data || e.data.type !== 'sa-legacy:init') return;
    if (ALLOWED_PARENTS.indexOf(e.origin) === -1) return;
    parentOrigin = e.origin;
    send();
  });

  function start() {
    // document.documentElement.style.overflow = 'hidden';   // no iframe scrollbar

    var css = document.createElement('style');
    css.textContent =
      'html{overflow:hidden !important;height:auto !important}' +
      'body{height:auto !important;min-height:0 !important}';
    document.head.appendChild(css);

    send();
    window.addEventListener('resize', send);
    if (window.ResizeObserver) new ResizeObserver(send).observe(document.body);
    document.addEventListener('load', send, true);
    setInterval(send, 1000);
  }

  if (document.body) start();
  else window.addEventListener('DOMContentLoaded', start);
})();
window.sa = (function(){
    'use strict';
    var _csrf = window.sa.csrf;
    var _vues = {};
    var _maps = [];
    
    const phoneNumbers = window.sa.phoneNumbers
    var q = document.location.search.match(/country=([A-Z][A-Z])(?:&|$)/);
    var country_code = q ? q[1] : window.sa.iso_3166_2 || localStorage.getItem('country_code') || 'GB';
    const info = {
        referrer:(window.sa.ref||Document.referrer||'').replace('https://www.selectiveasia.com',''),
        country_code,
        currency_code:['US'].indexOf(country_code) >= 0 ? 'USD' : 'GBP',
        device:window.sa.dev,
        journey:JSON.parse(localStorage.getItem('journey')||'[]')
    }
    // Update stats
    if(sa.referrer){
        if(!Array.isArray(info.journey) || info.journey.length == 0){
            info.journey = [sa.referrer];
        }else{
            if(sa.referrer != info.journey[info.journey.length-1]){
                info.journey.push(sa.referrer);
            }
        }
    }
    if(info.journey.length == 0 || document.location.pathname != info.journey[0]){
        info.journey.unshift(document.location.pathname);
    }
    try{localStorage.setItem('country_code',info.country_code)}catch(x){}
    try{localStorage.setItem('journey',JSON.stringify(info.journey || []))}catch(x){}    
    function event(a, b, c){
        try {
            var trackers = ga.getAll();
            var i, len;
            for (i = 0, len = trackers.length; i < len; i += 1) {
                if (trackers[i].get('trackingId') === "UA-513159-1") {
                    trackers[i].send('event', a, b, c);
                    return true
                }
            }
        } catch(e) {}
        return false;
    }
    function getClientId(){
        try {
            return document.cookie.match(/_ga=([^;]+);/)[1];
        } catch(e) {}
        return null;
    }
    function getGclids(){
        try{
            var storedValue = localStorage.getItem('sa_gclids') || "[]";
            var sa_gclids = JSON.parse(storedValue);
            return sa_gclids;
        }catch(ex){
            return [];
        }
    }
    function debounce(f, timeout = 250) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = window.setTimeout(() => {
                f.apply(undefined, args);
            }, timeout);
        };
    }
    return {
        event,debounce,
        getParam(key){
            const params = new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop),
            })
            return params[key]
        },
        getFormData(form){
            let qth = []
            try{
                qth = JSON.parse(localStorage.getItem("qt_history")) || [];
            } catch(e) {}
            const data = {
                data:{
                    web_journey: sa.info.journey,
                    gacid: getClientId(),
                    gclids: getGclids(),
                    qt_history: qth
                }
            }
            const formData = new FormData(form)
            for (var key of formData.keys()) {
                if(key.startsWith('_')){
                    data[key] = formData.get(key);
                }else{
                    data.data[key] = formData.get(key);
                }
            }
            formData.append('_token',_csrf)
            if(!data.hasOwnProperty('_token')){
                data._token = _csrf
            }
            return data
        },
        async submit(form, extra, withFiles, errorHandler){
            withFiles = withFiles || false
            // Forms
            const data = this.getFormData(form, withFiles)
            if(extra){
                for(var key in extra){
                    if(key.startsWith('_')){
                        data[key] = extra[key];
                    }else{
                        data.data[key] = extra[key];
                    }
                }
            }
            const params = {
                method: 'POST',
                cache: 'no-cache'
            }
            if(withFiles){
                const formData = new FormData()
                for(var key in data){
                    if(key == 'data'){
                        formData.append(key, JSON.stringify(data[key]))
                    }else{
                        formData.append(key, data[key])
                    }
                }
                for(var key in withFiles){
                    formData.append(key, withFiles[key])
                }
                params.body = formData
            }else{
                params.headers = { 'Content-Type': 'application/json'}
                params.body = JSON.stringify(data)
            }
            const response = await fetch('/submit', params);
            if(response.status >= 200 && response.status < 400){
                if(response.headers.get('content-type') == 'application/json'){
                    try{
                        return response.json();
                    }catch(x){
                      throw new Error("Submission failed "+ x.getMessage())
                    }
                }else{
                    try{
                        return response.blob()
                    }catch(x){
                      throw new Error("Submission failed "+ x.getMessage())
                    }
                }
            }else if(errorHandler){
                errorHandler(response)
            }
            throw new Error("Submission failed")
        },
        addMap(data){
            _maps.push(data)
        },
        getVues(){
            return _vues
        },
        getMaps(){
            return _maps
        },
        registerVueApp(selector, app){
            _vues[selector] = app
        },
        csrf(){
            const searchParams = (new URL(document.location.href)).searchParams
            document.querySelectorAll('form').forEach(function(e){
                for (const k of searchParams.keys()) {
                    const input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    input.setAttribute("name", k);
                    input.setAttribute("value", searchParams.get(k));
                    e.appendChild(input);
                }
                const input = document.createElement("input");
                input.setAttribute("type", "hidden");
                input.setAttribute("name", "_token");
                input.setAttribute("value", _csrf);
                e.appendChild(input);
            });
        },
        setCurrency(c){
            document.body.dataset.currency=c
        },
        info,
        phoneNumbers,
        gotoSignup(){
            document.querySelector('#footer-newsletter-signup input[name="first_name"]').scrollIntoView()
            document.querySelector('#footer-newsletter-signup input[name="first_name"]').select()
        }
    }
})()